module.exports = __webpack_public_path__ + "img/kiribati.8f96004c.svg";